import { ComponentType, createContext, Fragment, PropsWithChildren } from 'react';

export type CustomSearchExtensionPropsContextType = {
	advancedSearchUrl: string;
	cloudId: string;
	displayName: string;
	getSpaceIdsFromSpaceKeys: (spaceKeys: string[]) => Promise<string[]>;
	isAdminHubAIEnabled: boolean;
	orgId: string;
	peopleDirectoryUrl: string;
	userId: string;
	errorBoundaryComponent?: ComponentType<PropsWithChildren<{}>>;
	experienceStartComponent?: ComponentType<PropsWithChildren<{}>>;
	experienceSuccessComponent?: ComponentType<{}>;
};

const defaultContext: CustomSearchExtensionPropsContextType = {
	advancedSearchUrl: '',
	cloudId: '',
	displayName: '',
	getSpaceIdsFromSpaceKeys: async () => [],
	isAdminHubAIEnabled: false,
	orgId: '',
	peopleDirectoryUrl: '',
	userId: '',
	errorBoundaryComponent: Fragment,
	experienceStartComponent: Fragment,
	experienceSuccessComponent: Fragment,
};

export const CustomSearchExtensionPropsContext =
	createContext<CustomSearchExtensionPropsContextType>(defaultContext);
